import { getAddress, isAddress } from 'viem'

export const tronAddressToBytes32 = (address: string): `0x${string}` => {
    const cleanAddress = address.toLowerCase().replace('0x', '')
    return `0x${cleanAddress.padStart(64, '0')}`
}

export const tronBytes32ToAddress = (bytes32: `0x${string}`): string => {
    const addressHex = `0x${bytes32.slice(-40)}`
    return getAddress(addressHex)
}

export const isValidTronBytes32Address = (bytes32: string): boolean => {
    if (bytes32.length !== 66) {
        return false
    }
    try {
        const address = tronBytes32ToAddress(bytes32 as `0x${string}`)
        return isAddress(address)
    } catch {
        return false
    }
}
